<template>
  <div>
    <div class="langkah-1" v-if="step_show == 1">
      1. Masuk ke aplikasi Facebook Anda, lalu tekan gambar profile dan pilih
      <b>"Setelan & Privasi"</b>.
      <center>
        <img
          src="/assets/img/tutor-logout/step-1.png"
          width="70%"
          class="border border-secondary shadow rounded mt-2"
        />
      </center>
    </div>
    <div class="langkah-2" v-if="step_show == 2">
      2. Setelah itu, pilih <b>"Pengaturan"</b>.
      <center>
        <img
          src="/assets/img/tutor-logout/step-2.png"
          width="70%"
          class="border border-secondary shadow rounded mt-2"
        />
      </center>
    </div>
    <div class="langkah-3" v-if="step_show == 3">
      3. Kemudian, pilih <b>"Integrasi Bisnis"</b> pada pojok kiri bawah
      halaman.
      <center>
        <img
          src="/assets/img/tutor-logout/step-3.png"
          width="70%"
          class="border border-secondary shadow rounded mt-2"
        />
      </center>
    </div>
    <div class="langkah-4" v-if="step_show == 4">
      4. Maka akan muncul Online Media Monitoring yang ditautkan. Lalu pilih
      <b>"Hapus"</b> dan konfirmasi penghapusan.
      <center>
        <img
          src="/assets/img/tutor-logout/step-4.png"
          width="100%"
          class="border border-secondary shadow rounded mt-2"
        />
      </center>
    </div>
    <div class="mt-3 d-flex">
      <div class="ml-auto">
        <button
          class="btn btn-sm mr-2"
          v-if="step_show > 1"
          @click="previousStep"
        >
          Sebelumnya
        </button>
        <button class="btn btn-success btn-sm" @click="nextStep()">
          <span v-if="step_show < 4">Selanjutnya</span>
          <span v-else>Selesai</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  name: "modal_logout_fb_tutorial",
  data() {
    return {
      step_show: 1,
    };
  },
  methods: {
    nextStep() {
      if (this.step_show < 4) {
        this.step_show++;
      } else {
        $("#modalSlideUp").modal("hide");
      }
    },
    previousStep() {
      if (this.step_show > 1) {
        this.step_show--;
      }
    },
  },
};
</script>